<template>
  <b-row>
    <b-col>
      <b-card body-class="py-2">
        <section class="list-view-heading">
          <ModuleViewHeading :module-id="Modules.FINANZAS" :profile-id="Profiles.PERSONAL" reference="cheques" summary-only />
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions"><TabHeaderActions /></div>
            <div class="list-view-heading__controls-end">
              <b-button variant="link" class="list-view-icon-btn" :class="{ 'list-view-icon-btn--active': filtersOpen }" v-b-tooltip.hover.bottom :title="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'" :aria-label="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'" @click="filtersOpen = !filtersOpen"><AppIcon name="filter" :fill="filtersOpen" /></b-button>
              <b-button variant="link" class="list-view-icon-btn list-view-icon-btn--primary" v-b-tooltip.hover.bottom title="Agregar cheque" aria-label="Agregar cheque" @click="add"><AppIcon name="add" /></b-button>
            </div>
          </div>
        </section>
        <b-collapse v-model="filtersOpen">
          <div class="list-view-toolbar__filters">
            <div class="list-view-filter" style="width:150px;"><label class="filter-label">Desde (vto.)</label><b-form-input type="date" size="sm" v-model="filters.date_start" /></div>
            <div class="list-view-filter" style="width:150px;"><label class="filter-label">Hasta (vto.)</label><b-form-input type="date" size="sm" v-model="filters.date_end" /></div>
            <div class="list-view-filter" style="flex:1 1 180px;max-width:240px;"><label class="filter-label">Estado</label><v-select :options="arr.filters.available" v-model="filters.available" placeholder="Todos" :multiple="false" :select-on-tab="true" /></div>
            <b-button variant="outline-dark" size="sm" @click="load" v-b-tooltip.hover title="Aplicar filtros" style="height:31px;width:31px;padding:0;flex-shrink:0;"><AppIcon name="filter" /></b-button>
          </div>
        </b-collapse>
      </b-card>
      
      <b-card no-body class="cheques-detail-movimientos">
            <b-table class="app-table cheques-table mb-0"
                    responsive
                    sticky-header="60vh"
                    :hover="true"
                    :stacked="isMobileViewport ? 'md' : false"
                    :fixed="!isMobileViewport"
                    :items="table.items"
                    :fields="table.fields"
                    :filter="table.filter"
                    :current-page="table.currentPage"
                    :per-page="table.perPage"
                    v-if="table.items.length">                       
                  
                <template v-slot:table-colgroup="scope">
                  <col
                    v-for="field in scope.fields"                    
                    :key="field.key"
                    :style="{ width: field.width }"
                  >
                </template> 

                <template v-slot:cell(origen)="data">
                  <div v-if="data.item.origen" :id="'origen-extra-'+data.item.id" style="cursor: pointer;" v-b-tooltip.hover.bottom :title="data.item.origen.customer">
                    {{ data.item.origen.customer }}
                  </div>
                  <b-popover v-if="data.item.origen" :target="'origen-extra-'+data.item.id" triggers="hover" placement="top">
                    <template #title>Datos de Origen</template>

                    <span v-if="data.item.origen.point_sale">
                      {{data.item.origen.types_vouchers}} <br>
                      {{data.item.origen.point_sale.toString().padStart(4,'0') + '-' + data.item.origen.number.toString().padStart(8,'0')}} 
                      <hr>
                      {{moment(data.item.origen.date).format('DD MMMM YYYY')}} <br>
                      ({{data.item.origen.customer_id}}) - {{data.item.origen.customer}} 
                      <hr>
                      {{ data.item.origen.observations }}                      
                    </span>
                  </b-popover>                  
                </template>

                <template v-slot:cell(date)="data">
                  <div v-if="data.item.date">
                    {{ moment(data.item.date).format('DD MMMM YYYY') }}
                  </div>
                </template>

                <template v-slot:cell(days)="data">
                  <div v-if="data.item.date && data.item.date_expiration">
                    {{ moment(data.item.date_expiration).diff(moment(), 'days') }}
                  </div>
                </template>

                <template v-slot:cell(date_expiration)="data">
                  <div v-if="data.item.date_expiration">
                    <b>{{ moment(data.item.date_expiration).format('DD MMMM YYYY') }}</b>
                  </div>
                </template>

                <template v-slot:cell(cheque)="data">
                  <div class="cheques-cell-main" v-b-tooltip.hover.bottom :title="data.item.bank + ' · ' + data.item.number">
                    <strong>{{ data.item.bank }}</strong>
                    <span>N.º {{ data.item.number }}</span>
                  </div>
                  <div class="cheques-cell-meta" v-if="data.item.nd || data.item.observations">
                    <b-badge v-if="data.item.nd" variant="secondary" v-b-tooltip.hover.bottom title="Cheque no declarado">No declarado</b-badge>
                    <span v-if="data.item.observations" class="cheques-observations-chip" v-b-tooltip.hover.bottom :title="data.item.observations"><AppIcon name="chat" /> Observación</span>
                  </div>
                </template>

                <template v-slot:cell(dates)="data">
                  <div class="cheques-cell-main"><span>Emisión: {{ moment(data.item.date).format('DD/MM/YYYY') }}</span><strong>Vto.: {{ moment(data.item.date_expiration).format('DD/MM/YYYY') }}</strong></div>
                  <span class="cheques-cell-meta">{{ moment(data.item.date_expiration).diff(moment(), 'days') }} días</span>
                </template>

                <template v-slot:cell(circuit)="data">
                  <div class="cheques-circuit-row" v-if="data.item.origen" :id="'origen-circuit-'+data.item.id" v-b-tooltip.hover.bottom :title="data.item.origen.customer"><span>Origen</span><strong>{{ data.item.origen.customer }}</strong></div>
                  <b-popover v-if="data.item.origen" :target="'origen-circuit-'+data.item.id" triggers="hover" placement="top"><template #title>Datos de origen</template><span v-if="data.item.origen.point_sale">{{ data.item.origen.types_vouchers }}<br>{{ data.item.origen.point_sale.toString().padStart(4,'0') + '-' + data.item.origen.number.toString().padStart(8,'0') }}<hr>{{ moment(data.item.origen.date).format('DD MMMM YYYY') }}<br>({{ data.item.origen.customer_id }}) - {{ data.item.origen.customer }}<hr>{{ data.item.origen.observations }}</span></b-popover>
                  <div class="cheques-circuit-row" v-if="data.item.destino" :id="'destino-circuit-'+data.item.id" v-b-tooltip.hover.bottom :title="data.item.destino.supplier"><span>Destino</span><strong>{{ data.item.destino.supplier }}</strong></div>
                  <b-popover v-if="data.item.destino" :target="'destino-circuit-'+data.item.id" triggers="hover" placement="top"><template #title>Datos de destino</template><span v-if="data.item.destino.point_sale">{{ data.item.destino.types_vouchers }}<br>{{ data.item.destino.point_sale.toString().padStart(4,'0') + '-' + data.item.destino.number.toString().padStart(8,'0') }}<hr>{{ moment(data.item.destino.date).format('DD MMMM YYYY') }}<br>({{ data.item.destino.supplier_id }}) - {{ data.item.destino.supplier }}<hr>{{ data.item.destino.observations }}</span></b-popover>
                </template>

                <template v-slot:cell(bank)="data">
                  <span v-b-tooltip.hover.bottom :title="data.item.bank">{{ data.item.bank }}</span>
                </template>

                <template v-slot:cell(number)="data">
                  <span v-b-tooltip.hover.bottom :title="data.item.number">{{ data.item.number }}</span>
                </template>

                <template v-slot:cell(amount)="data">
                  <b>{{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyCode}).format(data.item.amount)}}</b>
                </template>

                <template v-slot:cell(transmitter)="data">
                  <div class="cheques-cell-main" v-b-tooltip.hover.bottom :title="data.item.transmitter_name + (data.item.transmitter_documents_number ? ' · CUIT ' + data.item.transmitter_documents_number : '')">
                    <strong v-if="data.item.transmitter_name">{{ data.item.transmitter_name }}</strong>
                    <span v-if="data.item.transmitter_documents_number">CUIT {{ data.item.transmitter_documents_number }}</span>
                  </div>
                </template>

                <template v-slot:cell(observations)="data">
                  <div v-if="data.item.observations" v-b-tooltip.hover.bottom :title="data.item.observations">
                    <span v-if="isMobileViewport">{{ data.item.observations }}</span>
                    <AppIcon v-else name="chat" />
                  </div>                                      
                </template>

                <template v-slot:cell(nd)="data">
                  <b-badge v-if="data.item.nd">SI</b-badge>            
                </template>   


                <template v-slot:cell(destino)="data">                                    
                  <div v-if="data.item.destino" :id="'destino-extra-'+data.item.id" style="cursor: pointer;" v-b-tooltip.hover.bottom :title="data.item.destino.supplier">
                    {{ data.item.destino.supplier }}
                  </div>
                  <b-popover v-if="data.item.destino" :target="'destino-extra-'+data.item.id" triggers="hover" placement="top">
                    <template #title>Datos de Destino</template>                    

                    <span v-if="data.item.destino.point_sale">
                      {{data.item.destino.types_vouchers}} <br>
                      {{data.item.destino.point_sale.toString().padStart(4,'0') + '-' + data.item.destino.number.toString().padStart(8,'0')}} 
                      <hr>
                      {{moment(data.item.destino.date).format('DD MMMM YYYY')}} <br>
                      ({{data.item.destino.supplier_id}}) - {{data.item.destino.supplier}} 
                      <hr>
                      {{ data.item.destino.observations }}
                    </span>
                  </b-popover>                  
                </template>

                <template v-slot:cell(f_action)="data">
                  <b-dropdown right no-caret size="sm" variant="link" boundary="window" :toggle-class="isMobileViewport ? 'cheques-action-toggle-labeled' : 'app-table-action-toggle'" :class="{ 'pull-right': !isMobileViewport }">
                    <template #button-content><AppIcon name="more_vert" :class="{ 'mr-1': isMobileViewport }" /><span v-if="isMobileViewport">Opciones</span></template>
                    <b-dropdown-item @click="edit(data.item)">
                      <AppIcon name="edit" class="mr-1" /> Editar
                    </b-dropdown-item>
                    <b-dropdown-item @click="remove(data.item)">
                      <AppIcon name="delete" class="mr-1 text-danger" /> Eliminar
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
            </b-table>
            <EmptyState v-else icon="receipt_long" title="No se encontraron cheques" />
            <div class="app-table-footer cheques-table-footer" v-if="table.items.length"><span>{{ getRowCount(table.items) }} registros</span></div>
      </b-card>

      <b-row align-h="end" v-if="table.items.length" class="mt-2">
        <b-col sm="4">      
          <b-card no-body class="cheques-detail-totales">
            <b-table-simple hover responsive class="app-table m-0">
              <b-thead>
                <b-tr>                      
                  <b-th width="50%" class="text-right">
                    <div class="mr-1">Total</div>
                  </b-th>                                
                  <b-th width="50%" class="text-right">
                    <div class="mr-1">Resumen</div>                        
                  </b-th>                                    
                </b-tr>
              </b-thead>  
              <b-tbody> 
                <b-tr>                                            
                  <b-td class="text-right align-middle cash-cheque-amount-totals">   
                    <div class="mr-1" v-if="true" :class="{'cash-cheque-text-danger':this.amountTotal<0, 'cash-cheque-text-success': this.amountTotal>0}">
                      {{Intl.NumberFormat('es-AR',{style:'currency',currency:'ARS'}).format(  this.amountTotal )}}
                    </div>            
                  </b-td>
                  <b-td class="text-right align-middle">        
                    <div class="mr-1 cash-cheque-amount-totals" :class="{'cash-cheque-text-danger':this.getAmountResumen()<0, 'cash-cheque-text-success':this.getAmountResumen()>0}">
                      {{Intl.NumberFormat('es-AR',{style:'currency',currency:'ARS'}).format( this.getAmountResumen() )}}
                    </div>            
                  </b-td>                                    
                </b-tr>
              </b-tbody>
            </b-table-simple>            
          </b-card>
        </b-col>
      </b-row>

      <b-card body-class="py-2" class="mt-2 cheques-page-footer">
        <b-row>
          <b-col>
            <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
              <AppIcon name="back" class="mr-1" />
              Volver
            </b-button>                        
          </b-col>

          <b-col>
            <nav>
              <b-pagination class="pull-right mb-0"
                            size="sm"
                            pills=""
                            :total-rows="getRowCount(table.items)"
                            :per-page="table.perPage"
                            v-model="table.currentPage" />
            </nav>
          </b-col>          
        </b-row>
      </b-card>

      <!-- ########################### -->
      <!-- #####     MODALES     ##### -->
      <!-- ########################### -->

      <!-- CRUD MAIN -->
      <b-modal v-model="modal.form.active"
              :key="modal.form._id"
              :id="modal.form._id">                  
        <template #modal-header><div class="app-modal-header"><span class="app-modal-header__icon"><AppIcon :name="crud.form.id ? 'edit' : 'add'" /></span><h5 class="app-modal-header__title">{{ modal.form.title }}</h5></div></template>

        <b-row>           
          <b-col md="6">
            <b-form-group label="Número">
              <b-form-input type="text"
                            size="sm"
                            v-model="crud.form.number"
                            required
                            placeholder="Ingresar el número">
              </b-form-input>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="Importe">
              <b-input-group prepend="$" size="sm">            
                <b-form-input v-model="crud.form.amount" 
                              type="number" 
                              setp="0.01" 
                              min="0.00"
                              :readonly="crud.form.id>0">
                </b-form-input>            
              </b-input-group>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="Fecha">
              <b-form-datepicker size="sm"  
                                 v-model="crud.form.date" 
                                 placeholder="Fecha" 
                                 local="es">
              </b-form-datepicker>                      
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="Vencimiento">
              <b-form-datepicker size="sm" 
                                 v-model="crud.form.date_expiration" 
                                 placeholder="Fecha Vencimiento" 
                                 local="es">
              </b-form-datepicker>                      
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group label="Banco">
              <b-form-input type="text"
                            size="sm"
                            v-model="crud.form.bank"
                            required
                            placeholder="Ingresar el banco">
              </b-form-input>
            </b-form-group>
          </b-col>
          
          <b-col md="6">
            <b-form-group label="Nombre Emisor">
              <b-form-input type="text"
                            size="sm"
                            v-model="crud.form.transmitter_name"
                            required
                            placeholder="Ingresar el nombre del emisor">
              </b-form-input>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="CUIT Emisor">
              <b-form-input type="text"
                            size="sm"
                            v-model="crud.form.transmitter_documents_number"
                            required
                            placeholder="Ingresar el CUIT del emisor">
              </b-form-input>
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group label="Observaciones">
              <app-textarea                
                v-model="crud.form.observations"
                placeholder="Ingresar las observaciones..."
                rows="3"
                max-rows="6"></app-textarea>
            </b-form-group>
          </b-col>  

          <b-col md="12" class="mb-3">       
            <b-form-group label="Tipo de Cheque" description="Si la opción se activa, los movimientos realizados, solo pueden utilizarse desde un punto de venta no declarado.">         
              <b-form-checkbox v-model="crud.form.nd" 
                                switch 
                                size="sm">
                ND
              </b-form-checkbox>                      
            </b-form-group>      
          </b-col>           
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.form.active=false"><AppIcon name="x" class="mr-1" /> Cancelar</b-button>
          <b-button variant="dark" @click="save()"><AppIcon name="save" class="mr-1" /> Guardar</b-button>
        </div>
      </b-modal>
    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'  
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import ModuleViewHeading from '@/components/inc/module/ModuleViewHeading'
  import Helper from '@/handler/helper' 
  import moment from 'moment'
  import Storage from '@/handler/storageLocal'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'

  export default {
    components: {
      ModuleViewHeading,
      TabHeaderActions,
    },
    data: () => {
      return {      
        Modules,
        Profiles,
        access: {
          module_id: Modules.FINANZAS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'cheques',
          elements: {}
        },  
        table : {
          items: [],
          fields: [],
          filter: null,
          currentPage: 1,
          perPage: 50,
        },      
        crud: {
          form: {
            id: 0,
            number: 0,
            date: '',
            date_expiration: '',
            amount: 0,
            bank: '',
            transmitter_name: '',
            transmitter_documents_number: '',
            observations: '',
            nd: false,
          },                 
        },
        modal: {
          form: {
            active: false,
            title: ''
          },        
        },
        arr: {
          filters : {
            available: [
              {code: true, label: 'En cartera'},
              {code: false, label: 'Entregado'}
            ]
          },                       
        },        
        filters: {
          date_start: '',
          date_end: '',
          available: null,
        },
        amountTotal: 0,
        filtersOpen: false,
        isMobileViewport: false,
        mobileMql: null,
      }
    },
    created () {     
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    },  
    mounted() {
      this.filtersOpen = Storage.getValue('filters_open_cheques') == 'true'
      this.mobileMql = window.matchMedia('(max-width: 767.98px)')
      this.isMobileViewport = this.mobileMql.matches
      this.mobileMql.addEventListener('change', this.updateMobileViewport)
      this.loadFieldTable()
      this.getAmountTotal()

      this.filterLoad()
      this.restoreFilterStorage() 

      this.load()

      this._start = true
    },
    beforeDestroy() {
      if(this.mobileMql) this.mobileMql.removeEventListener('change', this.updateMobileViewport)
    },
    activated() {
      if(this._start) {
        this._start = false
        return false
      } 

      this.getAmountTotal()
      this.filterLoad()
      this.load()        
    },         
    computed: {
      getCurrencyCode() {
        return 'ARS'
      }
    },
    watch: {
      filtersOpen(value) {
        Storage.setValue('filters_open_cheques', value ? 'true' : 'false')
      },
      isMobileViewport() {
        this.loadFieldTable()
      }
    },
    methods: {
      updateMobileViewport(e) {
        this.isMobileViewport = e.matches
      },
      alignClass(desktopClass) {
        return this.isMobileViewport ? 'text-left' : desktopClass
      },
      loadFieldTable() {
        if(!this.isMobileViewport) {
          this.table.fields = [
            {key: 'id', label: 'ID', class: 'align-middle text-center font-weight-bold', width:'5%'},
            {key: 'cheque', label: 'Cheque', class: 'align-middle', width:'19%'},
            {key: 'dates', label: 'Fechas', class: 'align-middle', width:'20%'},
            {key: 'transmitter', label: 'Emisor', class: 'align-middle', width:'23%'},
            {key: 'circuit', label: 'Origen / destino', class: 'align-middle', width:'22%'},
            {key: 'amount', label: 'Importe', class: 'align-middle text-right', width:'9%'},
            {key: 'f_action', label: '', class: 'align-middle', width:'2%'},
          ]
          return
        }
        this.table.fields = [
          {key: 'id', label: 'ID', class: 'align-middle font-weight-bold ' + this.alignClass('text-center'), width:'3%'},
          {key: 'origen', label: 'Origen', class: 'align-middle', width:'8%'},
          {key: 'bank', label: 'Banco', class: 'align-middle', width:'8%'},
          {key: 'number', label: 'Número', class: 'align-middle ' + this.alignClass('text-center'), width:'8%'},
          {key: 'date', label: 'Fecha', class: 'align-middle ' + this.alignClass('text-center'), width:'8%'},
          {key: 'date_expiration', label: 'Vencimiento', class: 'align-middle ' + this.alignClass('text-center'), width:'10%'},
          {key: 'days', label: 'Días', class: 'align-middle ' + this.alignClass('text-center'), width:'5%'},
          {key: 'transmitter', label: 'Emisor', class: 'align-middle', width:'20%'},
          {key: 'amount', label: 'Importe', class: 'align-middle ' + this.alignClass('text-right'), width:'10%'},
          {key: 'observations', label: this.isMobileViewport ? 'Observaciones' : '', class: 'align-middle ' + this.alignClass('text-center'), width:'5%'},
          {key: 'nd', label: 'ND', class:'align-middle', width:'5%'},
          {key: 'destino', label: 'Destino', class: 'align-middle', width:'8%'},
          {key: 'f_action', label: this.isMobileViewport ? 'Acción' : '', class: 'align-middle', width:'2%'},
        ]
      },
      confirmDialog(message, options) {
        var danger = !!options.danger
        var icon = options.icon || (danger ? 'warning' : 'help')
        var title = this.$createElement('span', { class: 'app-confirm-header__title' }, [
          this.$createElement('AppIcon', { props: { name: icon } }),
          options.title
        ])
        return this.$bvModal.msgBoxConfirm(message, {
          title: title,
          size: 'sm',
          buttonSize: 'sm',
          okVariant: danger ? 'danger' : 'dark',
          okTitle: options.okTitle,
          cancelTitle: options.cancelTitle || 'Cancelar',
          footerClass: 'p-2',
          headerClass: danger ? 'app-confirm-header app-confirm-header--danger' : 'app-confirm-header',
          hideHeaderClose: false,
          centered: true
        })
      },
      getRowCount (items) {
        return items.length
      },
      filterLoad() { 
        this.filters.date_start = moment().format('YYYY-MM-DD') 
        this.filters.date_end = moment().add(30, 'days').format('YYYY-MM-DD') 
      },
      load() {
        this.saveFilterStorage()    
        
        let loader = this.$loading.show()  
        
        var result = serviceAPI.filtrarCheques(this.filters, this.table.currentPage)        

        result.then((response) => {
          loader.hide()          
          this.table.items = response.data.data
          this.table.items.forEach(element => {            
            if(element.date_expiration <= moment().subtract(25, 'days').format('YYYY-MM-DD') && element.available) {
              element._rowVariant = 'danger'  
            }            
            if(element.date_expiration > moment().subtract(25, 'days').format('YYYY-MM-DD') && element.date_expiration <= moment().add(15, 'days').format('YYYY-MM-DD') && element.available) {
              element._rowVariant = 'warning'  
            }
            if(element.date_expiration > moment().add(15, 'days').format('YYYY-MM-DD') && element.available) {
              element._rowVariant = 'success'  
            }

            if(!element.available) {
              element._rowVariant = 'secondary'  
            }            
          });
        })
        .catch(error => {                         
          loader.hide()
          this.$awn.alert(Error.showError(error))
        });     
      },
      add() {
        this.crud.form.id = 0
        this.crud.form.number = 0
        this.crud.form.date = ''
        this.crud.form.date_expiration = ''
        this.crud.form.amount = 0
        this.crud.form.bank = ''
        this.crud.form.transmitter_name = ''
        this.crud.form.transmitter_documents_number = ''
        this.crud.form.observations = ''
        this.crud.form.nd = false

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Nuevo Cheque"
        this.modal.form.active = true
      },
      edit(item) {
        this.crud.form.id = item.id
        this.crud.form.number = item.number
        this.crud.form.date = item.date
        this.crud.form.date_expiration = item.date_expiration
        this.crud.form.amount = item.amount
        this.crud.form.bank = item.bank
        this.crud.form.transmitter_name = item.transmitter_name
        this.crud.form.transmitter_documents_number = item.transmitter_documents_number
        this.crud.form.observations = item.observations
        this.crud.form.nd = item.nd
        
        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Editar Cheque"
        this.modal.form.active = true
      },
      remove(item) {
        this.crud.form.id = item.id
        this.crud.form.number = item.number 

        this.confirmDialog('¿Desea borrar el cheque ' + this.crud.form.number + '?', {
          title: 'Borrar cheque',
          icon: 'delete',
          danger: true,
          okTitle: 'Eliminar'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.eliminarCheque(this.crud.form.id);

            result.then((response) => {      
              this.modal.form.active = false        
              loader.hide()
              this.load()
              this.$awn.success("Registro eliminado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      save() {
        let loader = this.$loading.show();
        if (this.crud.form.id) {
          var result = serviceAPI.editarCheque(this.crud.form);
        } else {
          var result = serviceAPI.agregarCheque(this.crud.form);
        }

        result.then((response) => {
          this.modal.form.active = false
          loader.hide()
          this.load()

          this.getAmountTotal()
          
          this.$awn.success("Datos guardados con éxito");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },     

      getAmountTotal() {        
        let result = serviceAPI.sumarChequesDisponibles();
        result.then((response) => {          
          this.amountTotal = parseFloat(response.data)
        })
      },
      getAmountResumen() {
        let total = 0
        this.table.items.forEach(element => {
          total = total + parseFloat(element.amount)
        });
        
        return total
      },  

      // FILTROS SAVE
      saveFilterStorage() {
        Storage.setValue('filter_cash_cheques', JSON.stringify(this.filters))
      },
      restoreFilterStorage() {
        if(Storage.getValue('filter_cash_cheques')) {
          this.filters = JSON.parse(Storage.getValue('filter_cash_cheques'))
        }         
      },             
    }    
  }
</script>
<style scoped>
  .cash-cheque-amount-totals {
    font-size: 15px;
    color: var(--app-color-success);
    font-weight: 800;
  }
  .cash-cheque-text-success {
    color: var(--app-color-success);
  }
  .cash-cheque-text-danger {
    color: var(--app-color-danger);
  }
  .cheques-table-footer { padding-right: 12px; }
  .cheques-table.app-table th,
  .cheques-table.app-table td { padding: 0.55rem 0.6rem; }
  .cheques-cell-main { display: grid; gap: 2px; }
  .cheques-cell-main strong { color: var(--app-color-text); font-weight: var(--app-font-semibold); }
  .cheques-cell-meta { align-items: center; color: var(--app-color-text-secondary); display: inline-flex; font-size: var(--app-text-xs); gap: 6px; margin-top: 4px; }
  .cheques-cell-meta .material-symbols-rounded { color: var(--app-color-primary); font-size: 16px; vertical-align: -3px; }
  .cheques-observations-chip { align-items: center; background: var(--app-color-primary-soft); border-radius: 999px; color: var(--app-color-primary-active); cursor: help; display: inline-flex; font-size: var(--app-text-xs); font-weight: var(--app-font-semibold); gap: 3px; padding: 2px 7px; }
  .cheques-observations-chip .material-symbols-rounded { color: inherit; font-size: 14px; vertical-align: 0; }
  .cheques-circuit-row { align-items: baseline; cursor: pointer; display: flex; gap: 6px; line-height: 1.45; }
  .cheques-circuit-row + .cheques-circuit-row { border-top: 1px solid var(--app-color-border); margin-top: 3px; padding-top: 3px; }
  .cheques-circuit-row > span { color: var(--app-color-text-secondary); flex: 0 0 48px; font-size: var(--app-text-xs); font-weight: var(--app-font-semibold); text-transform: uppercase; }
  .cheques-circuit-row > strong { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .cheques-page-footer { background: var(--app-color-surface); border: 1px solid var(--app-color-border-strong); box-shadow: 0 -3px 12px rgba(7, 58, 78, 0.13), 0 6px 16px rgba(7, 58, 78, 0.11); }
  .btn.cheques-action-toggle-labeled { align-items: center; background: transparent !important; border: none !important; box-shadow: none !important; color: var(--app-color-text-secondary) !important; display: inline-flex !important; font-size: var(--app-text-sm); height: auto !important; justify-content: flex-start; min-height: 0; padding: 0 !important; width: auto !important; }
  .btn.cheques-action-toggle-labeled:hover,
  .btn.cheques-action-toggle-labeled:focus { color: var(--app-color-primary) !important; text-decoration: underline; }
</style>
